export default __webpack_public_path__ + "static/media/fa.bundle.4764bd7e.svg";